import useStyles from "../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import { navigationItems } from '../../../containers/thirdparties/thirdparty-sheet/ThirdpartySheetUtils';
import _, { isEmpty } from 'lodash';
import i18next from 'i18next';
import React, { useEffect, useRef } from 'react';
// import { hasOption } from '../../../services/common/Utils';
import { PrivilegeEnum } from '../../../services/common/RolesUtils';
import { hasOption } from '../../../services/common/Utils';
import { Subscription } from '../../../services/common/Constants';
import EAColorIcon from '../../common/EAColorIcon';
import { MenuItem, Select } from '@mui/material';
import clsx from "clsx";

function StickyMenu({
                      hasAnyOfPrivilegesOnScopedResource,
                      hasAnyOfPrivileges,
                      state,
                      thirdpartyRisks,
                      thirdparty,
                      setCurrentSection,
                      currentSection,
                      fromPanel,
                      scrollRefPanel = null
                    }) {
  const { classes } = useStyles();
  const scrollRef = useRef(null);
  const itemsRef = useRef({});
  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = React.useState(false);
  const [displayedNavigationItems, setDisplayedNavigationItems] = React.useState(navigationItems);

  const navigationItemsControl = [
    // {
    //   name: "owlin",
    //   checkAutorisation: () => hasOption(state.accounts, state.account.id, "OWLIN") && hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_OWLIN_SOURCE)
    // },
    // {
    //   name: "esg",
    //   checkAutorisation: () => hasOption(state.accounts, state.account.id, Subscription.DATABLOCKS_ESG) && hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_DNB_ESG_SOURCE)
    // },
    // {
    //   name: "ecovadis",
    //   checkAutorisation: () => hasOption(state.accounts, state.account.id, "ECOVADIS") && thirdpartyRisks?.ecovadis && hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_ECOVADIS_SOURCE)
    // },
    {
      name: "attributes",
      checkAutorisation: () => hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_ATTRIBUTE_VALUE, PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_CALCULATED_ATTRIBUTE)
      || (hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_CREATE_THIRD_PARTY) && hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_ATTRIBUTE_VALUE))
    },
    {
      name: "indicators",
      checkAutorisation: () => hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_INDICATOR)
    },
    {
      name: "risk",
      checkAutorisation: () => (!isEmpty(thirdpartyRisks))
    },
    {
      name: "datahub",
      checkAutorisation: () => hasOption(state.accounts, state.account.id, Subscription.DATA_HUB) 
                              && hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_DATA_HUB_SOURCE)
    },
    {
      name: "contextes",
      checkAutorisation: () => thirdparty.onboarded && hasAnyOfPrivilegesOnScopedResource(
        PrivilegeEnum.PRIVILEGE_VIEW_CONTEXT,
        PrivilegeEnum.PRIVILEGE_VIEW_CONTEXT_INFORMATION,
        PrivilegeEnum.PRIVILEGE_VIEW_CONTEXT_ATTRIBUTES
      )
    },
    {
      name: "dossiers",
      checkAutorisation: () => thirdparty.onboarded && hasAnyOfPrivilegesOnScopedResource(
        PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER,
        PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_INFORMATION,
        PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_ATTRIBUTE_VALUE
      )
    },
    {
      name: "documents",
      checkAutorisation: () => thirdparty.onboarded && hasAnyOfPrivilegesOnScopedResource(
        PrivilegeEnum.PRIVILEGE_VIEW_DOCUMENT
      )
    },
    {
      name: "contacts",
      checkAutorisation: () => thirdparty.onboarded && hasAnyOfPrivilegesOnScopedResource(
        PrivilegeEnum.PRIVILEGE_VIEW_CONTACT
      )
    },
    {
      name: "notes",
      checkAutorisation: () => true
    },
    {
      name: "archives",
      checkAutorisation: () => hasAnyOfPrivilegesOnScopedResource(
        PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER,
        PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_INFORMATION,
        PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_ATTRIBUTE_VALUE
      )
    },
  ];

  // Scroll sur la section (vertical)
  const goToSection = (id) => {
    setCurrentSection(id);
    const element = document.getElementById(id);

    if (!fromPanel && element) {
      window.scrollTo({
        top: element.offsetTop - 245,
        behavior: 'smooth'
      });
    }

    if (fromPanel && element) {
      scrollRefPanel.current.scrollTo({
        top: element.offsetTop - 260,
        behavior: 'smooth' });
    }
  }

  // Retire l'affichage des items de menu inférieur à l'actuel
  useEffect(() => {
    const currentIndex = navigationItems.findIndex(item => item.sectionId === currentSection);
    setDisplayedNavigationItems(navigationItems.slice(currentIndex));
  }, [currentSection]);

  return (
    <div className={classes.navigationAncreWrapper} style={{ top: fromPanel ? 60 : 50 }}>
      {/*Burger menu*/}
      <div
        className={classes.burgerWrapper}
        onClick={() => setIsBurgerMenuOpen(!isBurgerMenuOpen)}
      >
        <EAColorIcon icon={"/thirdparty/stickyMenu/burger"} />
        <Select
          id="burger-menu"
          open={isBurgerMenuOpen}
          value={currentSection || ''}
          onChange={(e) => {goToSection(e.target.value);}}
          sx={{
            visibility: "hidden",
            position: "absolute"
          }}
        >
          {navigationItems.filter(item => {
            const controlItem = _.find(navigationItemsControl, { name: item.sectionId });
            return controlItem && controlItem.checkAutorisation();
          }).map((item, index) => (
            <MenuItem value={item.sectionId} key={index} >
              <EAColorIcon
                icon={item.icon}
                svgStyle={{ position: "relative", top: "2px", marginRight: "10px", width: "20px" }}
                color={currentSection === item.sectionId ? "" : "#C6CBD9"}
              />
              <span className={classes.burgerItemText}>
                {i18next.t(item.name)}
              </span>
            </MenuItem>
          ))}
        </Select>
      </div>

      {/*Menu horizontal*/}
      <div
        className={classes.navigationAncreWrapper}
        ref={scrollRef}
      >
        <div className={classes.navigationAncreItemsWrapper}>
          {displayedNavigationItems.filter(item => {
            const controlItem = _.find(navigationItemsControl, { name: item.sectionId });
            return controlItem && controlItem.checkAutorisation();
          }).map((item, index) => (
            <div
              className={clsx({
                [classes.navigationAncreItem] : true,
                [classes.navigationAncreItemActive] : currentSection === item.sectionId,
              })}
              key={index}
              onClick={() => goToSection(item.sectionId)}
              ref={(el) => itemsRef.current[item.sectionId + "itemMenu"] = el}
            >
              <EAColorIcon icon={item.icon} svgStyle={{position: "relative", top: "2px"}} />
              {i18next.t(item.name)}
            </div>
          ))}
          <div style={{width: "100vw"}}/>
        </div>
      </div>
    </div>
  );
}

export default StickyMenu;
